import posthog from "posthog-js";

const token = process.env.REACT_APP_POSTHOG_PROJECT_TOKEN;
const apiHost = process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";

if (token) {
  posthog.init(token, {
    api_host: apiHost,
    // Initial pageview + React Router history changes, retaining the query
    // string so ?ref=FMG-XXXXXX landings stay distinguishable.
    capture_pageview: { path: true, search: true, hash: false },
    // Session replay stays off.
    disable_session_recording: true,
    // Conservative autocapture: link/button clicks only — never inputs,
    // change, or submit events. Text/attributes masked.
    autocapture: {
      element_allowlist: ["a", "button"],
      dom_event_allowlist: ["click"],
    },
    mask_all_text: true,
    mask_all_element_attributes: true,
    capture_copied_text: false,
    // Redact secret-looking query params while keeping ?ref= intact.
    before_send: (event) => {
      if (!event || !event.properties) return event;
      const properties = { ...event.properties };
      for (const key of ["$current_url", "$initial_current_url", "$referrer"]) {
        if (typeof properties[key] === "string") {
          try {
            const url = new URL(properties[key]);
            for (const parameter of [...url.searchParams.keys()]) {
              if (/token|secret|password|passwd|api[_-]?key|auth|session|email/i.test(parameter)) {
                url.searchParams.set(parameter, "[REDACTED]");
              }
            }
            properties[key] = url.toString();
          } catch {}
        }
      }
      return { ...event, properties };
    },
  });
}

export default posthog;
